import type { AnchorRect } from './dayUiStore';

/** The element drawing block group `groupKey` (day lane or one of the week lanes). */
export function groupElement(groupKey: string): HTMLElement | undefined {
  return Array.from(document.querySelectorAll<HTMLElement>('[data-group-key]')).find(
    (candidate) => candidate.dataset['groupKey'] === groupKey,
  );
}

/** Viewport rectangle of the element drawing `groupKey`, for anchoring popovers. */
export function groupAnchor(groupKey: string): AnchorRect | null {
  const element = groupElement(groupKey);
  if (element === undefined) return null;
  const rect = element.getBoundingClientRect();
  return { left: rect.left, top: rect.top, right: rect.right, bottom: rect.bottom };
}

/** Move keyboard focus onto the block drawing `groupKey` (no scrolling). */
export function focusGroup(groupKey: string): void {
  groupElement(groupKey)?.focus({ preventScroll: true });
}

/**
 * Anchor of the overlap popover: beside the lane, so it never covers the blocks it is about
 * (ui-redesign §3.8). Falls back to the block's own rectangle.
 */
export function conflictAnchor(groupKey: string): AnchorRect | null {
  const element = groupElement(groupKey);
  const anchor = groupAnchor(groupKey);
  if (element === undefined || anchor === null) return null;
  const lane = element.closest('[data-testid="lane"]')?.getBoundingClientRect();
  return lane === undefined ? anchor : { ...anchor, left: lane.left, right: lane.right };
}
